const Items = [
    {
        groupClass: 'is-primary',
        group: 'Confiar en los Recursos de Dios',
        number: 'C-1',
        theme: 'Su Espíritu',
        ref: '1 Corintios 3:16',
        text: {
            lbla: '¿No sabéis que sois templo de Dios y que el Espíritu de Dios habita en vosotros?'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Confiar en los Recursos de Dios',
        number: 'C-2',
        theme: 'Su Espíritu',
        ref: '1 Corintios 2:12',
        text: {
            lbla: 'Y nosotros hemos recibido, no el espíritu del mundo, sino el Espíritu que viene de Dios, para que conozcamos lo que Dios nos ha dado gratuitamente,'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Confiar en los Recursos de Dios',
        number: 'C-3',
        theme: 'Su Fuerza',
        ref: 'Isaías 41:10',
        text: {
            lbla: 'No temas, porque yo estoy contigo; no te desalientes, porque yo soy tu Dios. Te fortaleceré, ciertamente te ayudaré, sí, te sostendré con la diestra de mi justicia.'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Confiar en los Recursos de Dios',
        number: 'C-4',
        theme: 'Su Fuerza',
        ref: 'Filipenses 4:13',
        text: {
            lbla: 'Todo lo puedo en Cristo que me fortalece.'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Confiar en los Recursos de Dios',
        number: 'C-5',
        theme: 'Su Fidelidad',
        ref: 'Lamentaciones 3:22, 23',
        text: {
            lbla: 'Que las misericordias del Señor jamás terminan, pues nunca fallan sus bondades; son nuevas cada mañana; ¡grande es tu fidelidad!'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Confiar en los Recursos de Dios',
        number: 'C-6',
        theme: 'Su Fidelidad',
        ref: 'Numeros 23:19',
        text: {
            lbla: 'Dios no es hombre, para que mienta, ni hijo de hombre, para que se arrepienta. ¿Lo ha dicho Él, y no lo hará?, ¿ha hablado, y no lo cumplirá?'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Confiar en los Recursos de Dios',
        number: 'C-7',
        theme: 'Su Paz',
        ref: 'Isaías 26:3',
        text: {
            lbla: 'Al de firme propósito guardarás en perfecta paz, porque en ti confía.'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Confiar en los Recursos de Dios',
        number: 'C-8',
        theme: 'Su Paz',
        ref: '1 Pedro 5:7',
        text: {
            lbla: 'echando toda vuestra ansiedad sobre Él, porque Él tiene cuidado de vosotros.'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Confiar en los Recursos de Dios',
        number: 'C-9',
        theme: 'Su Provisión',
        ref: 'Romanos 8:32',
        text: {
            lbla: 'El que no eximió ni a su propio Hijo, sino que lo entregó por todos nosotros, ¿cómo no nos concederá también con Él todas las cosas?'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Confiar en los Recursos de Dios',
        number: 'C-10',
        theme: 'Su Provisión',
        ref: 'Filipenses 4:19',
        text: {
            lbla: 'Y mi Dios proveerá a todas vuestras necesidades, conforme a sus riquezas en gloria en Cristo Jesús.'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Confiar en los Recursos de Dios',
        number: 'C-11',
        theme: 'Su Ayuda en Tentación',
        ref: 'Hebreos 2:18',
        text: {
            lbla: 'Pues por cuanto Él mismo fue tentado en el sufrimiento, es poderoso para socorrer a los que son tentados.'
        }
    },
    {
        groupClass: 'is-primary',
        group: 'Confiar en los Recursos de Dios',
        number: 'C-12',
        theme: 'Su Ayuda en Tentación',
        ref: 'Salmos 119:9-11',
        text: {
            lbla: '¿Cómo puede el joven guardar puro su camino? Guardando tu palabra. Con todo mi corazón te he buscado; no dejes que me desvíe de tus mandamientos. En mi corazón he atesorado tu palabra, para no pecar contra ti.'
        }
    }
];

export default Items;